import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { CalendarIconV2, CompleteAnim, MplButton, MplModal } from '@mopla/ui';

interface ISuccessStepProps {
	open: boolean;
	formattedStartDate: string;
	onConfirm: VoidFunction;
	isActivePause: boolean;
}

export const DTicketResumeSubscriptionSuccessStep: FC<ISuccessStepProps> = ({
	open,
	formattedStartDate,
	onConfirm,
	isActivePause,
}) => {
	const { t } = useTranslation('dticketResumeSubscription');

	return (
		<MplModal
			open={open}
			testId="dticket-resume-subscription-success-modal"
			icon={<CompleteAnim />}
			title={
				isActivePause
					? t('success_modal.active_pause.title')
					: t('success_modal.upcoming_pause.title')
			}
			content={
				<Stack direction="row" alignItems="center" gap={1}>
					<CalendarIconV2 size={24} color="#0E1C5B" />
					<Typography variant="body1" color="primary.main">
						<Trans
							i18nKey={
								isActivePause
									? 'dticketResumeSubscription:success_modal.active_pause.valid_from'
									: 'dticketResumeSubscription:success_modal.upcoming_pause.valid_from'
							}
							values={{ date: formattedStartDate }}
							components={{
								bold: <strong />,
							}}
						/>
					</Typography>
				</Stack>
			}
			buttons={
				<MplButton
					fullWidth
					onClick={onConfirm}
					testId="dticket-resume-subscription-success-button"
				>
					{t('success_modal.button')}
				</MplButton>
			}
		/>
	);
};
